import { render, staticRenderFns } from "./AdvertisingStatus.vue?vue&type=template&id=3bed3c12"
import script from "./AdvertisingStatus.vue?vue&type=script&lang=js"
export * from "./AdvertisingStatus.vue?vue&type=script&lang=js"
import style0 from "./AdvertisingStatus.vue?vue&type=style&index=0&id=3bed3c12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports